var React = require('react');

function ButtonStagePlayInline (props) {
    return React.createElement("g",props,React.createElement("g",{"transform":"translate(4.000000, 4.000000)"},[React.createElement("circle",{"fill":"#F5F2F0","cx":"23","cy":"23","r":"23","key":0}),React.createElement("polygon",{"fill":"#262626","points":"18 14 31 23 18 32","key":1})]));
}

ButtonStagePlayInline.defaultProps = {"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = ButtonStagePlayInline;

ButtonStagePlayInline.default = ButtonStagePlayInline;
